export default __webpack_public_path__ + "images/geochart.bf37bb485491e1af75d24170039e06be.svg";